import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { apiFetch } from '../lib/api.ts';
import { dateTime } from '../lib/format.ts';

interface AuditRow {
  id: number;
  userId: number | null;
  userEmail: string | null;
  action: string;
  resourceType: string | null;
  resourceId: string | null;
  ip: string | null;
  success: boolean;
  details: unknown;
  occurredAt: string;
}

interface AuditResp {
  rows: AuditRow[];
}

export function AdminAuditLogPage() {
  const [limit] = useState(200);
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin', 'audit-log', limit],
    queryFn: () => apiFetch<AuditResp>(`/api/admin/audit-log?limit=${limit}`),
  });

  return (
    <>
      <header className="main-header">
        <h1 className="main-title">Audit log</h1>
        <span className="main-subtitle">{data ? `${data.rows.length} entries` : ''}</span>
      </header>
      <Link to="/admin" className="back-link">← Admin</Link>

      {isLoading && <div className="loading">Loading…</div>}
      {error && <div className="error">{(error as Error).message}</div>}

      {data && (
        <section className="panel">
          <header className="panel-header">
            <h2 className="panel-title">Recent events</h2>
            <span className="panel-subtitle">retained indefinitely</span>
          </header>
          <table className="table">
            <thead>
              <tr>
                <th>Time</th>
                <th>User</th>
                <th>Action</th>
                <th>Resource</th>
                <th>IP</th>
                <th>OK</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.id}>
                  <td className="mono" style={{ fontSize: 11 }}>{dateTime(r.occurredAt)}</td>
                  <td>{r.userEmail ?? <em style={{ color: 'var(--text-dim)' }}>system</em>}</td>
                  <td className="mono">{r.action}</td>
                  <td className="mono" style={{ fontSize: 11 }}>
                    {r.resourceType ? `${r.resourceType}:${r.resourceId ?? ''}` : '—'}
                  </td>
                  <td className="mono" style={{ fontSize: 11 }}>{r.ip ?? '—'}</td>
                  <td>
                    <span className={`badge ${r.success ? 'badge-ok' : 'badge-cancel'}`}>
                      {r.success ? 'ok' : 'fail'}
                    </span>
                  </td>
                  <td
                    className="mono"
                    style={{
                      fontSize: 11,
                      color: 'var(--text-dim)',
                      maxWidth: 400,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {r.details ? JSON.stringify(r.details) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}
    </>
  );
}
